import React, { useEffect, useState } from "react";
import {
  Input,
  Space,
  Form,
  Button,
  notification,
  message,
  DatePicker,
} from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import policyRequest from "./PolicyRequest";
import ReactQuill from "react-quill"; // Import ReactQuill for rich text editing
import "react-quill/dist/quill.snow.css"; // Import ReactQuill styles
import dayjs from "dayjs";

export const UpdatePrivacyPolicy = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams(); // Get the id from the URL params
  const [policyData, setPolicyData] = useState(null); // Store the fetched policy data
  const [content, setContent] = useState(""); // State to manage the content for ReactQuill editor

  const fetchPolicyData = () => {
    setLoading(true);
    policyRequest
      .getPolicyById(id) // Assuming you have a method to get the policy by ID
      .then((response) => {
        const data = response?.data?.data || {};
        console.log(data);
        setPolicyData(data); // Save fetched data to policyData state
        setContent(data.content || ""); // Set the content for ReactQuill editor
        form.setFieldsValue({
          ...data, // Populate the form fields with fetched data
          effectiveDate: data.effectiveDate ? dayjs(data.effectiveDate) : null,
        });
      })
      .catch((error) => {
        message.error("Failed to fetch Policy data");
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    console.log(values);
    setLoading(true);

    // Adding the content from ReactQuill editor to the form data
    const updatedValues = { ...values, content };

    policyRequest
      .updatePolicy(id, updatedValues) // Assuming you have an API method for updating policy
      .then((res) => {
        if (res.status === 200) {
          notification.success({
            message: "Policy updated successfully",
          });
          navigate(-1, { state: { refresh: true } }); // Navigate to the previous page
        } else {
          notification.error({
            message: "Something went wrong",
          });
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to update Policy",
        });
        console.error("API Error:", e);
      });
  };

  const handleSubmit = () => {
    form.submit(); // Trigger form validation and submission
  };

  useEffect(() => {
    if (id) {
      fetchPolicyData(); // Fetch the policy data when editing a policy
    }
  }, [id]);

  return (
    <>
      <section>
        <div className="Create-Category">
          <Form.Item className="text-center submit-btn">
            <Space>
              <Button
                className="f-sub-btn btn-width"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3>Update Privacy Policy</h3>

          {/* Add Ant Design Form component and pass the form instance */}
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <div className="subscription">
              {/* Replaced Input with ReactQuill for rich text editing */}
              <Form.Item
                name="content"
                label="Content"
                className="subscription-plan"
                style={{ width: "100%" }}
                rules={[
                  { required: true, message: "Please enter the content" },
                ]}
              >
                <ReactQuill
                  value={content} // Bind ReactQuill value to the content state
                  onChange={setContent} // Update content state on change
                  placeholder="Enter Content"
                  style={{ height: "300px", width: "100%" }}
                />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="versionNumber"
                label="Version Number"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the version number",
                  },
                ]}
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter Version Number"
                />
              </Form.Item>
              <Form.Item
                name="effectiveDate"
                label="Effective Date"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please select the effective date",
                  },
                ]}
              >
                <DatePicker
                  placeholder="Select Effective Date"
                  style={{ width: "99%" }}
                />
              </Form.Item>
            </div>

            <div className="bottom-button">
              <div style={{ padding: "10px" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Save
                  <span>
                    <AiOutlineRight />
                  </span>
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};
